<template>
  <!-- 添加服务人员 -->
  <div class="container">
    <div class="vue padHorizontal10">
      <div class="header  flex flexJc-sb flexAi-c">
        <div class="text">选择服务人员</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="service flex  flexWrap">
        <div class="choose " v-for="(item, index) in chooselist" :key="index">
          <div
            @click="tabChoose(index, item)"
            class="list padVertical10 flex flexColumn flexAi-c flexJc-c"
            :class="chooseI === index ? 'newchoose_bg' : 'choose_bg'"
          >
            <div class="header">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.image"
                fit="cover"
              ></el-image>
            </div>
            <div class="center">
              {{ item.servername }}
            </div>
            <div class="center">
              擅长领域:{{ item.serviceSpecialize }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        title="已选择人员"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        width="20%"
        @closed="closed">
        <div class="header">
           <el-image style="width: 80" :src="chooseServer.image" fit="cover"></el-image></div>
        <div style="padding: 10px;">
            服务人员: {{ chooseServer.servername }}
        </div>
        <div style="padding: 10px;">
            擅长领域: {{ chooseServer.serviceSpecialize }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiGetServerList,
  apiGetServerWorkTime,
  apiServerAssignJK
} from '@/api/orderManage'
let that
export default {
  name: '',
  props: [''],

  data() {
    return {
      routerObj: '', // 传参的数据
      chooselist: [], // 列表
      chooseI: Number,
      dialogVisible: false,
      chooseServer: {},
    }
  },
  computed: {},

  beforeMount() {},

  mounted() {
    that = this
    if (this.$route.query.info !== undefined) {
      this.headText = '编辑服务人员'
      this.routerObj = JSON.parse(this.$Base64.decode(this.$route.query.info))
      this.GetServiceList()
    }
  },

  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 点击服务人员
    tabChoose(index, item) {
      console.log(item)
      this.chooseServer = item;
      this.dialogVisible = true;
    },
    // 弹窗--确定
    dialogClick() {
      console.log('this.chooseServer', this.chooseServer);
      apiServerAssignJK({
        indentId: this.routerObj.id,
        sid: this.chooseServer.id,
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 弹窗--关闭
    closed() {
      this.dialogVisible = false;
    },
    // 接口
    // 获取服务人员的列表
    GetServiceList() {
      apiGetServerList({
        lng: this.routerObj.lng,
        lat: this.routerObj.lat,
        cateType: this.routerObj.cateType
      }).then(res => {
        if (res.status === 0) {
          this.chooselist = res.data
          // res.data
        } else {
          this.$message({type: 'error', message: res.msg})
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .service {
    .choose {
      padding: 10px 0;
      width: 20%;
      .list {
        border: 1px solid #fff;
      }
      .list:hover {
        border: 1px solid #119685;
      }
    }
  }
}
/deep/ .time-data {
  .time-list {
    padding: 10px 0;
    width: 20%;
    border: 1px solid #fff;
  }
  .time-list {
    cursor: pointer;
  }
  .time-list:hover {
    color: #119685;
  }
  .time-list-click {
    border: 1px solid #119685;
    color: #119685;
  }
  .time-occupy {
    padding: 10px 0;
    width: 20%;
    border: 1px solid #fff;
    border: 1px solid #f3f3f3;
    color: #bdbdbd;
    cursor: not-allowed;
  }
}
</style>
